import React from 'react';
import {useTranslation} from '../../../../hooks/useTranslation';

import './index.scss';

function OtherFields({
  dropdownPosition,
  dropdownRef,
  handleChangeType,
  toggleDropdown,
}) {
  const {t} = useTranslation();
  
  const handleType = type => {
    handleChangeType(type);
    toggleDropdown();
  };

  return (
    <div className={`f-build__dropdown ${dropdownPosition}`} ref={dropdownRef}>
      <div
        className='f-build__dropdown-item'
        onClick={() => handleType('sump_sample')}
      >
        {t('createNewForm.components.fieldTypes.sumpSample')}
      </div>
      <div
        className='f-build__dropdown-item'
        onClick={() => handleType('sump_sample_optional')}
      >
        {t('createNewForm.components.fieldTypes.sumpSampleWithNA')}
      </div>
      <div
        className='f-build__dropdown-item'
        onClick={() => handleType('tank_condition')}
      >
        {t('createNewForm.components.fieldTypes.tankCondition')}
      </div>
      <div
        className='f-build__dropdown-item'
        onClick={() => handleType('cleaning_status')}
      >
        {t('createNewForm.components.fieldTypes.cleaningStatus')}
      </div>
      <div
        className='f-build__dropdown-item'
        onClick={() => handleType('microlab_test_result')}
      >
        {t('createNewForm.components.fieldTypes.microlabTestResult')}
      </div>
    </div>
  );
}

export default OtherFields;
